import React from "react";
import Gauge from "./Gauge";
import { Numeral } from "react-numeral";
import Image from "../../Tags/Image";
export default function Funding({ funding = {}, revenue = {}, data = {}, valuation = {} }) {
  const Card = ({ icon, label, value, doller = true }) => (
    <div className="p-6 border border-gray-200 bg-gray-50 rounded-xl flex-1">
      <Image src={icon} className="mb-5 no-invert" />
      <span className="text-[12px] capitalize whitespace-pre mb-2 leading-none block">{label}</span>
      <span className="text-gray-900 font-bold leading-none uppercase text-2xl block">
        {doller ? "$" : ""}

        <Numeral
          className="text-gray-900 font-bold leading-none uppercase "
          value={value}
          format={"0.[0]a"}
        />
      </span>
    </div>
  );
  return (
    <div className="border rounded-[14px] overflow-hidden border-border  bg-background relative mt-4  py-2 px-4">
      <h3 className="text-gray-900 my-2 mb-4">Financials and Funding</h3>
      {data?.stock_exchange_type !== "PRIVATE" && data?.stock_exchange_type && (
        <div className="p-6 inline-flex items-center space-x-6 border border-gray-200 bg-gray-50 rounded-xl">
          <Image className="no-invert" src="/images/ext/companyinfo/bank.svg" />
          <span>
            <span className="block text-xs text-gray-600">
              {data?.stock_exchange ? data?.stock_exchange : "-"}
            </span>
            <span className="block text-lg text-gray-900 font-bold">
              {data?.stock_symbol ? data?.stock_symbol : "-"}
            </span>
          </span>
        </div>
      )}
      <div className="flex my-4 justify-between space-x-4">
        {revenue?.amount_in_usd && (
          <Card value={revenue?.amount_in_usd} label="Annual Revenue" icon={"/images/ext/money.svg"} />
        )}
        {funding?.recent_round && funding?.recent_round?.amount_in_usd && (
          <Card
            value={funding?.recent_round?.amount_in_usd}
            label={funding?.recent_round?.name}
            icon={"/images/ext/money.svg"}
          />
        )}
        {funding?.total_funding_amount && (
          <Card
            value={funding?.total_funding_amount}
            label={"Total funding"}
            icon={"/images/ext/money.svg"}
          />
        )}
        {valuation?.amount_in_usd && (
          <Card value={valuation?.amount_in_usd} label={"Valuation"} icon={"/images/ext/valuation.svg"} />
        )}
      </div>

      {funding && funding?.investors && funding?.investors.length > 0 && (
        <div className="border border-gray-200 bg-gray-50 rounded-xl px-4 py-2 pb-1 mb-2">
          {/* <div className="h-[1px]  border-b my-5"></div> */}
          <h3 className="text-gray-900 my-2 mb-4">Investors</h3>
          <div>
            {funding &&
              funding?.investors &&
              funding?.investors.length > 0 &&
              funding?.investors.map((item) => (
                <>
                  {item && (item?.name !== "Others" || item?.name !== "others") && (
                    <span className="inline-block text-[12px] bg-blue-light-50 text-blue-light-700 border border-blue-light-200 px-2 py-1 rounded-[20px] mr-3 mb-3">
                      {item?.name}
                    </span>
                  )}
                </>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}
